import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Box, Flex } from "@100mslive/roomkit-react";
import SEO from "../Common/SEO";
import PublicProfileAbout from "./PublicProfileAbout";
import PublicProfileEvents from "./PublicProfileEvents";

const PublicProfileTabs = props => {
  const { profileData } = props;
  const { profileSlug, tabType } = useParams();
  const [selectedTab, setSelectedTab] = useState(tabType || "chat");
  const [tabList, setTabList] = useState("");

  useEffect(() => {
    let list = {};
    if (profileData?.isEvents) {
      list["speaker"] = {
        name: "Speaker in Events",
        to: "speaker",
        component: (
          <PublicProfileEvents
            profileId={profileData?.profileId}
            name={profileData?.name}
          />
        ),
      };
    }
    list["about"] = {
      name: "About",
      to: "about",
      component: <PublicProfileAbout about={profileData?.bio} />,
    };

    setSelectedTab(list?.[tabType] ? tabType : Object.keys(list)?.[0]);
    setTabList(list);
  }, [tabType, profileData]);
  return (
    tabList?.[selectedTab] && (
      <React.Fragment>
        <Flex className="event-page-company-tabs events6ix-tabs">
          {Object.keys(tabList).map((item, key) => (
            <Link
              key={key}
              to={`/u/${profileSlug}${
                tabList?.[item]?.to &&
                tabList?.[item]?.to !== Object.keys(tabList)?.[0]
                  ? "/" + tabList?.[item]?.to
                  : ""
              }`}
              className={`event-page-company-tabs-link ${
                tabList?.[item]?.to === selectedTab ? "active" : ""
              }`}
            >
              {tabList?.[item]?.name}
            </Link>
          ))}
        </Flex>
        <Box className="event-page-company-content no-space">
          {tabList?.[selectedTab]?.component}
          <SEO
            title={`${profileData?.name}  | ${tabList?.[selectedTab]?.name} | 6ix`}
            description={
              profileData?.bio?.trim() ||
              `Discover ${profileData?.name}'s latest ${tabList?.[
                selectedTab
              ]?.name?.toLowerCase()} on 6ix.`
            }
          />
        </Box>
      </React.Fragment>
    )
  );
};

export default PublicProfileTabs;
